import CrmDealsAPI from '../../api/crmDeals';

// Cada carga do quadro leva um número. Busca digitada rápido dispara cargas
// concorrentes, e a resposta de "ge" chegando depois da de "geiza" pintaria o
// quadro com o resultado velho.
let boardRequestSeq = 0;
let dealsRequestSeq = 0;
// 25 páginas de 200: teto de 5.000 negócios por carga.
const MAX_DEAL_PAGES = 25;

export const state = {
  records: [],
  columns: [],
  labelTotals: {},
  funnels: [],
  meta: { totalCount: 0, currentPage: 1, totalPages: 1 },
  currentDeal: null,
  origins: [],
  paymentMethods: [],
  lostReasons: [],
  products: [],
  tasks: [],
  uiFlags: {
    isFetching: false,
    isFetchingBoard: false,
    isFetchingFunnels: false,
    isFetchingDeal: false,
    isUpdatingDeal: false,
    isUpdating: false,
  },
};

export const getters = {
  getDeals: $state => $state.records,
  getDealsByStage: $state => stageId =>
    $state.records.filter(deal => deal.stage_id === stageId),
  getColumns: $state => $state.columns,
  getLabelTotals: $state => $state.labelTotals,
  getFunnels: $state => $state.funnels,
  getMeta: $state => $state.meta,
  getCurrentDeal: $state => $state.currentDeal,
  getOrigins: $state => $state.origins,
  getPaymentMethods: $state => $state.paymentMethods,
  getLostReasons: $state => $state.lostReasons,
  getProducts: $state => $state.products,
  getTasks: $state => $state.tasks,
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  async fetchLabelTotals({ commit }, params) {
    const { data } = await CrmDealsAPI.labelTotals(params);
    commit('SET_CRM_LABEL_TOTALS', data);
  },
  async fetchFunnels({ commit }) {
    commit('SET_CRM_UI_FLAG', { isFetchingFunnels: true });
    try {
      const { data } = await CrmDealsAPI.funnels();
      commit('SET_CRM_FUNNELS', data.payload);
    } finally {
      commit('SET_CRM_UI_FLAG', { isFetchingFunnels: false });
    }
  },

  async fetchBoard({ commit }, params) {
    boardRequestSeq += 1;
    const seq = boardRequestSeq;
    const isStale = () => seq !== boardRequestSeq;
    commit('SET_CRM_UI_FLAG', { isFetchingBoard: true });
    try {
      const { data } = await CrmDealsAPI.board(params);
      if (isStale()) return;
      commit('SET_CRM_COLUMNS', data.columns);
    } finally {
      if (!isStale()) commit('SET_CRM_UI_FLAG', { isFetchingBoard: false });
    }
  },

  // O servidor entrega no máximo 200 por página. Parar na primeira deixava
  // funil grande com negócio fora do quadro e da busca, enquanto o topo da
  // coluna contava todos.
  async fetchDeals({ commit }, params) {
    dealsRequestSeq += 1;
    const seq = dealsRequestSeq;
    const isStale = () => seq !== dealsRequestSeq;
    commit('SET_CRM_UI_FLAG', { isFetching: true });
    try {
      const { data } = await CrmDealsAPI.get(params);
      if (isStale()) return;
      commit('SET_CRM_DEALS', data.payload);
      commit('SET_CRM_META', data.meta);

      const lastPage = Math.min(data.meta.total_pages, MAX_DEAL_PAGES);
      for (let page = 2; page <= lastPage; page += 1) {
        // eslint-disable-next-line no-await-in-loop
        const { data: next } = await CrmDealsAPI.get({ ...params, page });
        if (isStale()) return;
        commit('APPEND_CRM_DEALS', next.payload);
      }
    } finally {
      if (!isStale()) commit('SET_CRM_UI_FLAG', { isFetching: false });
    }
  },

  async createFunnel({ commit, dispatch }, { name, stages }) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmDealsAPI.createFunnel({ name, stages });
      await dispatch('fetchFunnels');
      return data;
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async moveToStage({ commit }, { id, stageId }) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmDealsAPI.moveToStage(id, stageId);
      commit('UPDATE_CRM_DEAL', data);
      return data;
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  // Acha o negócio de uma conversa sem tocar em getDeals: aquela lista é do
  // quadro, e sobrescrevê-la a partir do detalhe da conversa esvaziaria o
  // Kanban de quem tivesse as duas telas abertas.
  async deleteDeal({ commit }, id) {
    await CrmDealsAPI.delete(id);
    commit('SET_CURRENT_DEAL', null);
    return id;
  },

  // Os negócios de um contato, para a aba "Negócio" do detalhe da conversa.
  // Não commita em getDeals: aquela lista é do quadro, e sobrescrevê-la a
  // partir da conversa esvaziaria o Kanban de quem tivesse as duas telas.
  async fetchDealsByContact(_ctx, contactId) {
    const { data } = await CrmDealsAPI.get({ contact_id: contactId });
    return data.payload || [];
  },

  async fetchDeal({ commit }, id) {
    commit('SET_CRM_UI_FLAG', { isFetchingDeal: true });
    try {
      const { data } = await CrmDealsAPI.getDeal(id);
      commit('SET_CURRENT_DEAL', data);
      return data;
    } finally {
      commit('SET_CRM_UI_FLAG', { isFetchingDeal: false });
    }
  },

  async fetchOrigins({ commit }) {
    const { data } = await CrmDealsAPI.origins();
    commit('SET_CRM_ORIGINS', data.payload);
  },

  async fetchPaymentMethods({ commit }) {
    const { data } = await CrmDealsAPI.paymentMethods();
    commit('SET_CRM_PAYMENT_METHODS', data.payload);
  },

  async fetchLostReasons({ commit }) {
    const { data } = await CrmDealsAPI.lostReasons();
    commit('SET_CRM_LOST_REASONS', data.payload);
  },

  async fetchProducts({ commit }) {
    const { data } = await CrmDealsAPI.products();
    commit('SET_CRM_PRODUCTS', data.payload);
  },

  // A aba "Todas as Tarefas" sempre pede status=all: o filtro (pendente/
  // atrasada/concluída) é aplicado no cliente, igual ao caminho conversacional.
  async createStandaloneTask({ dispatch }, task) {
    await CrmDealsAPI.createStandaloneTask(task);
    await dispatch('fetchTasks', { status: 'all' });
  },
  async updateStandaloneTask({ dispatch }, { id, ...task }) {
    await CrmDealsAPI.updateStandaloneTask(id, task);
    await dispatch('fetchTasks', { status: 'all' });
  },
  async deleteStandaloneTask({ dispatch }, id) {
    await CrmDealsAPI.deleteStandaloneTask(id);
    await dispatch('fetchTasks', { status: 'all' });
  },
  async fetchTasks({ commit }, params) {
    const { data } = await CrmDealsAPI.tasks(params);
    commit('SET_CRM_TASKS', data.payload);
  },

  async createProduct({ commit, dispatch }, product) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmDealsAPI.createProduct(product);
      await dispatch('fetchProducts');
      return data;
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async updateProduct({ commit, dispatch }, { id, product }) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmDealsAPI.updateProduct(id, product);
      await dispatch('fetchProducts');
      return data;
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async deleteProduct({ commit, dispatch }, id) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      await CrmDealsAPI.deleteProduct(id);
      await dispatch('fetchProducts');
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async createOrigin({ commit, dispatch }, origin) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmDealsAPI.createOrigin(origin);
      await dispatch('fetchOrigins');
      return data;
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async updateOrigin({ commit, dispatch }, { id, origin }) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmDealsAPI.updateOrigin(id, origin);
      await dispatch('fetchOrigins');
      return data;
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async deleteOrigin({ commit, dispatch }, id) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      await CrmDealsAPI.deleteOrigin(id);
      await dispatch('fetchOrigins');
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async createPaymentMethod({ commit, dispatch }, paymentMethod) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmDealsAPI.createPaymentMethod(paymentMethod);
      await dispatch('fetchPaymentMethods');
      return data;
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async updatePaymentMethod({ commit, dispatch }, { id, paymentMethod }) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmDealsAPI.updatePaymentMethod(id, paymentMethod);
      await dispatch('fetchPaymentMethods');
      return data;
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async deletePaymentMethod({ commit, dispatch }, id) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      await CrmDealsAPI.deletePaymentMethod(id);
      await dispatch('fetchPaymentMethods');
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async createLostReason({ commit, dispatch }, lostReason) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmDealsAPI.createLostReason(lostReason);
      await dispatch('fetchLostReasons');
      return data;
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async updateLostReason({ commit, dispatch }, { id, lostReason }) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmDealsAPI.updateLostReason(id, lostReason);
      await dispatch('fetchLostReasons');
      return data;
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async deleteLostReason({ commit, dispatch }, id) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      await CrmDealsAPI.deleteLostReason(id);
      await dispatch('fetchLostReasons');
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async updateDeal({ commit }, { id, deal }) {
    commit('SET_CRM_UI_FLAG', { isUpdatingDeal: true });
    try {
      const { data } = await CrmDealsAPI.updateDeal(id, deal);
      commit('SET_CURRENT_DEAL', data);
      commit('UPDATE_CRM_DEAL', data);
      return data;
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdatingDeal: false });
    }
  },

  // Tarefas e parcelas recarregam o negócio inteiro após a escrita: o
  // servidor recalcula paid_value a partir das parcelas pagas (ver
  // Crm::Deal#recalculate_paid_value!), então relemos em vez de tentar
  // reconstruir esse total no front.
  async createTask({ commit, dispatch }, { dealId, task }) {
    commit('SET_CRM_UI_FLAG', { isUpdatingDeal: true });
    try {
      await CrmDealsAPI.createTask(dealId, task);
      await dispatch('fetchDeal', dealId);
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdatingDeal: false });
    }
  },

  async updateTask({ commit, dispatch }, { dealId, taskId, task }) {
    commit('SET_CRM_UI_FLAG', { isUpdatingDeal: true });
    try {
      await CrmDealsAPI.updateTask(dealId, taskId, task);
      await dispatch('fetchDeal', dealId);
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdatingDeal: false });
    }
  },

  async deleteTask({ commit, dispatch }, { dealId, taskId }) {
    commit('SET_CRM_UI_FLAG', { isUpdatingDeal: true });
    try {
      await CrmDealsAPI.deleteTask(dealId, taskId);
      await dispatch('fetchDeal', dealId);
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdatingDeal: false });
    }
  },

  async generateInstallments(
    { commit, dispatch },
    { dealId, count, firstDueAt }
  ) {
    commit('SET_CRM_UI_FLAG', { isUpdatingDeal: true });
    try {
      await CrmDealsAPI.generateInstallments(dealId, {
        count,
        first_due_at: firstDueAt,
      });
      await dispatch('fetchDeal', dealId);
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdatingDeal: false });
    }
  },

  async updateInstallment(
    { commit, dispatch },
    { dealId, installmentId, installment }
  ) {
    commit('SET_CRM_UI_FLAG', { isUpdatingDeal: true });
    try {
      await CrmDealsAPI.updateInstallment(dealId, installmentId, installment);
      await dispatch('fetchDeal', dealId);
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdatingDeal: false });
    }
  },

  async deleteInstallment({ commit, dispatch }, { dealId, installmentId }) {
    commit('SET_CRM_UI_FLAG', { isUpdatingDeal: true });
    try {
      await CrmDealsAPI.deleteInstallment(dealId, installmentId);
      await dispatch('fetchDeal', dealId);
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdatingDeal: false });
    }
  },

  async addProductLine({ commit, dispatch }, { dealId, productLine }) {
    commit('SET_CRM_UI_FLAG', { isUpdatingDeal: true });
    try {
      await CrmDealsAPI.addProductLine(dealId, productLine);
      await dispatch('fetchDeal', dealId);
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdatingDeal: false });
    }
  },

  async removeProductLine({ commit, dispatch }, { dealId, lineId }) {
    commit('SET_CRM_UI_FLAG', { isUpdatingDeal: true });
    try {
      await CrmDealsAPI.removeProductLine(dealId, lineId);
      await dispatch('fetchDeal', dealId);
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdatingDeal: false });
    }
  },

  async createDeal({ commit }, deal) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmDealsAPI.createDeal(deal);
      return data;
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async updateFunnel({ commit, dispatch }, { id, name }) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmDealsAPI.updateFunnel(id, { name });
      await dispatch('fetchFunnels');
      return data;
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async deleteFunnel({ commit, dispatch }, id) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      await CrmDealsAPI.deleteFunnel(id);
      await dispatch('fetchFunnels');
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async createStage({ commit, dispatch }, { funnelId, stage }) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmDealsAPI.createStage(funnelId, stage);
      await dispatch('fetchFunnels');
      return data;
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async updateStage({ commit, dispatch }, { funnelId, stageId, stage }) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmDealsAPI.updateStage(funnelId, stageId, stage);
      await dispatch('fetchFunnels');
      return data;
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },

  async deleteStage({ commit, dispatch }, { funnelId, stageId }) {
    commit('SET_CRM_UI_FLAG', { isUpdating: true });
    try {
      await CrmDealsAPI.deleteStage(funnelId, stageId);
      await dispatch('fetchFunnels');
    } finally {
      commit('SET_CRM_UI_FLAG', { isUpdating: false });
    }
  },
};

export const mutations = {
  SET_CRM_DEALS($state, records) {
    $state.records = records;
  },
  // A ordem é por updated_at: negócio mexido entre uma página e outra pode vir
  // repetido na seguinte.
  APPEND_CRM_DEALS($state, records) {
    const known = new Set($state.records.map(deal => deal.id));
    $state.records = [
      ...$state.records,
      ...records.filter(deal => !known.has(deal.id)),
    ];
  },
  SET_CRM_COLUMNS($state, columns) {
    $state.columns = columns;
  },
  SET_CRM_FUNNELS($state, funnels) {
    $state.funnels = funnels;
  },
  SET_CRM_META($state, meta) {
    $state.meta = {
      totalCount: meta.total_count,
      currentPage: meta.current_page,
      totalPages: meta.total_pages,
    };
  },
  UPDATE_CRM_DEAL($state, deal) {
    const index = $state.records.findIndex(record => record.id === deal.id);
    if (index > -1) $state.records.splice(index, 1, deal);
  },
  SET_CURRENT_DEAL($state, deal) {
    $state.currentDeal = deal;
  },
  SET_CRM_ORIGINS($state, origins) {
    $state.origins = origins;
  },
  SET_CRM_PAYMENT_METHODS($state, paymentMethods) {
    $state.paymentMethods = paymentMethods;
  },
  SET_CRM_LOST_REASONS($state, lostReasons) {
    $state.lostReasons = lostReasons;
  },
  SET_CRM_PRODUCTS($state, products) {
    $state.products = products;
  },
  SET_CRM_TASKS($state, tasks) {
    $state.tasks = tasks;
  },
  SET_CRM_LABEL_TOTALS($state, totals) {
    $state.labelTotals = totals;
  },
  SET_CRM_UI_FLAG($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
};

export default { namespaced: true, state, getters, actions, mutations };
